import { useTranslation } from "react-i18next";
import { Manager } from "../../../Manager";
import { fetchBrands, type Brand } from "../../../../state/brands";
import {
  searchSuppliers,
  fetchSupplierById,
  type Supplier,
} from "../../../../state/suppliers";
import type { SearchParams, SortParams } from "../../../Manager/types";
import { useCallback } from "react";
import { Box } from "@radix-ui/themes";

const SEARCH_COLUMNS = ["name"];

export function ManageBrands() {
  const { t } = useTranslation();

  const fetchData = useCallback(
    (
      limit?: number,
      offset?: number,
      searchParams?: SearchParams,
      sortParams?: SortParams,
    ) => fetchBrands(limit, offset, searchParams, sortParams),
    [],
  );

  return (
    <Box p="4">
      <Manager.Root<Brand> title={t("brands.title")} fetchData={fetchData}>
        <Manager.Search>
          <Manager.TextSearch
            columns={SEARCH_COLUMNS}
            placeholder={t("brands.searchPlaceholder")}
          />
          <Manager.AutocompleteSearch<Supplier>
            filterKey="supplier_id"
            label={t("brands.supplier")}
            placeholder={t("suppliers.searchPlaceholder")}
            searchFn={searchSuppliers}
            fetchByIdFn={fetchSupplierById}
            getOptionLabel={(s) => s.name}
            getOptionValue={(s) => s.id}
          />
        </Manager.Search>

        <Manager.Sort columns={[{ key: "name", isDefault: true }]} />

        <Manager.Table>
          <Manager.Column<Brand>
            header={t("brands.name")}
            accessor={(b) => b.name}
            sortKey="name"
          />
          <Manager.Column<Brand>
            header={t("brands.supplier")}
            accessor={(b) => b.suppliers?.name ?? "—"}
          />
        </Manager.Table>
      </Manager.Root>
    </Box>
  );
}
